import type { ProjectDomain } from '@mybusinessmate/schema';
import { DOMAIN_META } from '../../lib/project-display';
import { cx } from '../../lib/cx';
import { Icon } from '../Icon';

// Literal class names so Tailwind generates them.
const TINT = {
  blue: 'bg-tag-blue-bg text-tag-blue-text',
  pink: 'bg-tag-pink-bg text-tag-pink-text',
  indigo: 'bg-tag-indigo-bg text-tag-indigo-text',
  amber: 'bg-tag-amber-bg text-tag-amber-text',
  red: 'bg-tag-red-bg text-tag-red-text',
  green: 'bg-tag-green-bg text-tag-green-text',
  grey: 'bg-tag-grey-bg text-tag-grey-text',
} as const;

/**
 * The project's domain icon in a rounded square: tinted on the client side (Figma C03.1), a dark tile with a
 * white icon on the staff side (Figma A05.1).
 */
export function DomainTile({
  domain,
  variant = 'tinted',
  className,
}: {
  domain: ProjectDomain;
  variant?: 'tinted' | 'dark';
  className?: string;
}) {
  const meta = DOMAIN_META[domain];
  return (
    <span
      aria-hidden
      className={cx(
        'flex size-(--mbm-size-icon-tile-project) shrink-0 items-center justify-center rounded-(--mbm-component-radius-icon-tile)',
        variant === 'dark' ? 'bg-action-primary text-text-on-dark' : TINT[meta.tone],
        className,
      )}
    >
      <Icon icon={meta.icon} size="md" />
    </span>
  );
}
